import {
  Controller as ControllerRHF,
  FormProvider as FormProviderRHF,
  useFieldArray as useRHFFieldArray,
  useForm as useRHFForm,
  useFormContext as useRHFFormContext,
  useWatch as useRHFWatch
} from "react-hook-form";

import {
  FormArrayInput,
  FormArrayTextArea,
  FormAttachments,
  Form as FormBase,
  FormCheckbox,
  FormColorPicker,
  FormDatePicker,
  FormDatePickerRaw,
  FormDropdownHelper,
  FormFileDragDrop,
  FormInputHelper,
  FormQuill,
  FormTextArea,
  FormTextEditor,
  FormUploadImage
} from "lib/Form/components";

import type { AppointmentNoteAttachment } from "models";
import type { FieldValues, Path } from "react-hook-form";

// Live bindings only — never call or destructure these at module top level (barrel cycle).
export const createFormHelper = <T extends FieldValues, A extends { url: string } = AppointmentNoteAttachment>() => ({
  FormProvider: FormProviderRHF,
  Controller: ControllerRHF,
  Form: FormBase<T>,
  Field: {
    ArrayInput: FormArrayInput<T>,
    ArrayTextArea: FormArrayTextArea<T>,
    Attachments: FormAttachments<T, A>,
    Checkbox: FormCheckbox<T>,
    ColorPicker: FormColorPicker<T>,
    DatePicker: FormDatePicker<T>,
    DatePickerRaw: FormDatePickerRaw<T>,
    Dropdown: FormDropdownHelper<T>(),
    FileDragDrop: FormFileDragDrop<T>,
    Input: FormInputHelper<T>(),
    Quill: FormQuill<T>,
    TextArea: FormTextArea<T>,
    TextEditor: FormTextEditor<T>,
    UploadImage: FormUploadImage<T>
  },
  useFormContext: useRHFFormContext<T>,
  useForm: useRHFForm<T>,
  useFieldArray: useRHFFieldArray<T>,
  useWatch: <N extends Path<T>>(name: N) => useRHFWatch<T, N>({ name })
});
